import React from 'react';
import { useLoan } from '../../stores/store';
import { usePrequal } from '../../stores/prequalStore';
import useConfig from '../../stores/config';
import { useTheme } from '../../hooks/useTheme';
import BlankLayout from '../BlankLayout';
import { BOAT_TRADER_SOURCE_ID } from '../../constants';
import { loadPrequalOverrides, getPrequalSource } from '../../utils';

type Props = {};

const PageNotFound: React.FC<Props> = () => {
  const loanStore = useLoan();
  const prequalStore = usePrequal();
  const { prequal } = prequalStore;
  const config = useConfig();
  const theme = useTheme(loanStore, config, true);

  if (theme != null) {
    const sourceId = getPrequalSource(config, prequal);
    loadPrequalOverrides(theme, sourceId);
  }

  return (
    <BlankLayout title="Page Not Found">
      <p style={{ textAlign: 'center' }}>
        Page Not Found!{' '}
        <a href={`/pre-qualify/?source=${BOAT_TRADER_SOURCE_ID}`}>
          Click here to Get Pre-Qualified for a Boat Loan.
        </a>
      </p>
    </BlankLayout>
  );
};

export default PageNotFound;
